export type PlanId = 'free' | 'basic' | 'comfort' | 'enterprise';

export interface Plan {
  id: PlanId;
  title: string;
  subtitle: string;
  price: string;
  priceNote?: string;
  ctaPrimary: string;
  ctaSecondary?: string;
  recommended?: boolean;
  features: string[];
  addOnsTitle?: string;
  addOns?: string[];
  stripePriceId?: string;
  stripeProductId?: string;
  stripeProductName?: string;
}

export const PLANS: Plan[] = [
  {
    id: 'free',
    title: 'Free',
    subtitle: 'Die Basis für kleine Verbände bis 10 Mitglieder',
    price: '0 €',
    priceNote: 'pro Mitglied/Monat',
    ctaPrimary: 'Kostenlos starten',
    features: [
      '10 Mitglieder',
      '20 GB Speicherplatz',
      'Vollständig eingerichtete Instanz in 24 Stunden',
      'Automatische Updates und Support',
      'Wechselmöglichkeit zu kostenpflichtigem Abonnement bei größerem Bedarf',
      'SSL-Verschlüsselung',
      'Kein benutzerdefiniertes Logo'
    ],
    addOnsTitle: 'Funktionsumfang',
    addOns: [
      'Mitgliederverwaltung',
      'Interner Kalender',
      'News Erstellung',
      'Dateiablage',
      'Event Planung'
    ],
    stripePriceId: 'price_1SPKjnDiFYz6dyHMvfRypmdB',
    stripeProductId: 'prod_TM2pcm1TcgDjo1',
    stripeProductName: 'Free'
  },
  {
    id: 'basic',
    title: 'Basic',
    subtitle: 'Die Basis für mittelgroße Verbände bis 100 Mitglieder',
    price: '5 €',
    priceNote: 'pro Mitglied/Monat',
    ctaPrimary: 'Mit Basic starten',
    features: [
      '100 Mitglieder',
      '200 GB Speicherplatz',
      'Vollständig eingerichtete Instanz in 24 Stunden',
      'Automatische Updates und Support',
      'Tägliches Backup der Daten',
      'Wechselmöglichkeit zu anderen Abonnements bei größerem Bedarf',
      'SSL-Verschlüsselung',
      'Benutzerdefiniertes Logo',
      'Benutzerdefinierte Farben'
    ],
    addOnsTitle: 'Funktionsumfang',
    addOns: [
      'Mitgliederverwaltung',
      'Interner Kalender',
      'News Erstellung',
      'Dateiablage',
      'Event Planung',
      'Sicherer Dokumenten Austausch',
      'Eigene Kommunikationsplattform für Mitglieder'
    ],
    stripePriceId: 'price_1SPKk6DiFYz6dyHMODVBKBIL',
    stripeProductId: 'prod_TM2pi7RB4Ronfw',
    stripeProductName: 'Basic'
  },
  {
    id: 'comfort',
    title: 'Comfort',
    subtitle: 'Größere Verbände – Erweiterte Funktionen & Produktivität',
    price: '8 €',
    priceNote: 'pro Mitglied/Monat',
    ctaPrimary: 'Mit Comfort starten',
    recommended: true,
    features: [
      '500 Mitglieder',
      '1000 GB Speicherplatz',
      'Vollständig eingerichtete Instanz in 24 Stunden',
      'Automatische Updates und Support',
      'Tägliches Backup der Daten',
      'Wechselmöglichkeit zu anderen Abonnements bei größerem Bedarf',
      'SSL-Verschlüsselung',
      'Benutzerdefiniertes Logo',
      'Benutzerdefinierte Farben'
    ],
    addOnsTitle: 'Funktionsumfang',
    addOns: [
      'Mitgliederverwaltung',
      'Interner Kalender',
      'News Erstellung',
      'Dateiablage',
      'Event Planung',
      'Sicherer Dokumenten Austausch',
      'Eigene Kommunikationsplattform für Mitglieder',
      'Individuelle Erweiterungen an Funktionen'
    ],
    stripePriceId: 'price_1SPKkVDiFYz6dyHMYCLYwteo',
    stripeProductId: 'prod_TM2qIkwE4YmG1J',
    stripeProductName: 'Comfort'
  },
  {
    id: 'enterprise',
    title: 'Enterprise',
    subtitle: 'Für große Verbände über 500 Mitglieder',
    price: 'ab 15 €',
    priceNote: 'pro Mitglied/Monat',
    ctaPrimary: 'Vertrieb kontaktieren',
    features: [
      'Unbegrenzte Anzahl Mitglieder',
      'Unbegrenzter Speicherplatz',
      'Vollständig eingerichtete Instanz in 24 Stunden',
      'Automatische Updates und Support',
      'Tägliches Backup der Daten',
      'SSL-Verschlüsselung',
      'Benutzerdefiniertes Logo',
      'Benutzerdefinierte Farben'
    ],
    addOnsTitle: 'Funktionsumfang',
    addOns: [
      'Mitgliederverwaltung',
      'Interner Kalender',
      'News Erstellung',
      'Dateiablage',
      'Event Planung',
      'Sicherer Dokumenten Austausch',
      'Eigene Kommunikationsplattform für Mitglieder',
      'Individuelle Erweiterungen an Funktionen'
    ],
    stripePriceId: 'price_1SPKkqDiFYz6dyHMWlskwvj1',
    stripeProductId: 'prod_TM2q9h58GmNcgj',
    stripeProductName: 'Enterprise'
  }
];
